import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

// import ActivityBadge from '../ActivityBadge';

export default class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  render() {
    return (
      <div className={css(styles.container, this.props.visible ? null : styles.container_hidden)}>
        <h2 className={css(styles.question)}>{this.props.question}</h2>
        <div className={css(styles.answer)}>{this.props.children}</div>
      </div>
    );
  }
}

FAQ.defaultProps = {
  visible: false,
};

FAQ.propTypes = {
  question: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node).isRequired,
    PropTypes.object,
  ]).isRequired,
  visible: PropTypes.bool,
};

const styles = StyleSheet.create({
  container_hidden: {
    display: 'none',
  },
  question: {
    marginBottom: 31,
    fontSize: 30,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    color: '#262626',
    lineHeight: '1.2',
  },
  answer: {
    ':not(.a) > p': {
      fontSize: 15,
      fontFamily: Theme.font_family_primary,
      fontWeight: Theme.font_weight_primary,
      color: '#000e1f',
      lineHeight: 1.8,

      ':not(:last-child)': {
        marginBottom: 15,
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/FAQ/index.js